<template>
  <div class="product-list">
    <!--搜索表单：按卡号、购买用户-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="卡号">
          <el-input size="small" v-model="searchForm.card_no" placeholder="请输入卡号" clearable></el-input>
        </el-form-item>
        <el-form-item label="购买用户">
          <el-input size="small" v-model="searchForm.nick_name" placeholder="请输入用户昵称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-wrap">
      <el-table :data="tableData" style="width: 100%" v-loading="loading">
        <el-table-column prop="card_no" label="卡号" width="160">
          <template slot-scope="scope">
            {{ scope.row.card_no || '-' }}
          </template>
        </el-table-column>

        <el-table-column prop="giftCard.name" label="礼品卡名称" width="120">
          <template slot-scope="scope">
            {{ scope.row.giftCard && scope.row.giftCard.name ? scope.row.giftCard.name : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="initial_value" label="面值" width="100">
          <template slot-scope="scope">
            {{ scope.row.initial_value !== undefined && scope.row.initial_value !== null ? '$' + scope.row.initial_value : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="balance" label="当前余额" width="100">
          <template slot-scope="scope">
            {{ scope.row.balance !== undefined && scope.row.balance !== null ? '$' + scope.row.balance : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            {{ scope.row.status_text || (scope.row.status !== undefined && scope.row.status !== null ? formatInstanceStatus(scope.row.status) : '-') }}
          </template>
        </el-table-column>
        <el-table-column prop="buyer.nickName" label="购买者" width="120">
          <template slot-scope="scope">
            {{ scope.row.buyer && scope.row.buyer.nickName ? scope.row.buyer.nickName : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="expire_time" label="有效期" width="160">
          <template slot-scope="scope">
            {{ scope.row.expire_time || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="购买时间" width="160"></el-table-column>
        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button @click="showDetail(scope.row)" type="text" size="small">查看详情</el-button>
            <el-button @click="showLedger(scope.row)" type="text" size="small" v-auth="'/gift_card/instance_list/ledger'">查看流水</el-button>
            <el-button @click="showBinding(scope.row)" type="text" size="small">绑定记录</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!--分页-->
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
        :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
        :total="totalDataNumber">
      </el-pagination>
    </div>

    <!--详情弹窗：卡片基础信息 + 消费记录（若有）-->
    <el-dialog title="礼品卡详情" :visible.sync="detailVisible" width="520px">
      <div v-if="detailRow" class="detail-content">
        <p><span class="label">卡号：</span>{{ detailRow.card_no || '-' }}</p>
        <!-- <p><span class="label">订单ID：</span>{{ detailRow.order_id || '-' }}</p> -->
        <p><span class="label">礼品卡名称：</span>{{ detailRow.giftCard && detailRow.giftCard.name ? detailRow.giftCard.name : '-' }}</p>
        <p><span class="label">初始面值：</span>{{ detailRow.initial_value !== undefined && detailRow.initial_value !== null ? '$' + detailRow.initial_value : '-' }}</p>
        <p><span class="label">当前余额：</span>{{ detailRow.balance !== undefined && detailRow.balance !== null ? '$' + detailRow.balance : '-' }}</p>
        <p><span class="label">状态：</span>{{ detailRow.status_text || (detailRow.status !== undefined && detailRow.status !== null ? formatInstanceStatus(detailRow.status) : '-') }}</p>
        <p><span class="label">购买者：</span>{{ detailRow.buyer && detailRow.buyer.nickName ? detailRow.buyer.nickName : '-' }}</p>
        <p><span class="label">有效期：</span>{{ detailRow.expire_time || '-' }}</p>
        <p><span class="label">购买时间：</span>{{ detailRow.create_time || '-' }}</p>
        <template v-if="detailRow.logList && detailRow.logList.length">
          <div class="detail-section">消费记录</div>
          <el-table :data="detailRow.logList" size="small" border style="width: 100%; margin-top: 8px;">
            <el-table-column prop="create_time" label="操作时间" width="140"></el-table-column>
            <el-table-column prop="type_text" label="操作类型" width="90"></el-table-column>
            <el-table-column prop="amount" label="变动金额" width="90"></el-table-column>
            <el-table-column prop="order_no" label="关联订单号" min-width="120"></el-table-column>
          </el-table>
        </template>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!--流水弹窗-->
    <el-dialog title="礼品卡流水" :visible.sync="ledgerVisible" width="960px">
      <ledger v-if="ledgerDetail" :detail="ledgerDetail" :logs="ledgerLogs" />
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="ledgerVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!--绑定记录弹窗-->
    <el-dialog title="绑定记录" :visible.sync="bindingVisible" width="720px">
      <el-table :data="bindingTableData" size="small" border style="width: 100%" v-loading="bindingLoading">
        <el-table-column prop="user.nickName" label="用户昵称" width="160">
          <template slot-scope="scope">
            {{ scope.row.user && scope.row.user.nickName ? scope.row.user.nickName : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="user.mobile" label="手机号" width="140">
          <template slot-scope="scope">
            {{ scope.row.user && scope.row.user.mobile ? scope.row.user.mobile : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="绑定时间" min-width="180"></el-table-column>
      </el-table>

      <div class="pagination" style="margin-top: 12px;">
        <el-pagination
          @size-change="handleBindingSizeChange"
          @current-change="handleBindingCurrentChange"
          background
          :current-page="bindingCurPage"
          :page-size="bindingPageSize"
          layout="total, prev, pager, next, jumper"
          :total="bindingTotal"
        />
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="bindingVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import GiftCardApi from '@/api/gift_card/gift_card.js';
import Ledger from './ledger.vue';

export default {
  components: { Ledger },
  data() {
    return {
      loading: true,
      tableData: [],
      pageSize: 10,
      totalDataNumber: 0,
      curPage: 1,
      searchForm: {
        card_no: '',
        nick_name: ''
      },
      detailVisible: false,
      detailRow: null,
      ledgerVisible: false,
      ledgerDetail: null,
      ledgerLogs: [],

      bindingVisible: false,
      bindingLoading: false,
      bindingInstanceId: 0,
      bindingTableData: [],
      bindingPageSize: 10,
      bindingTotal: 0,
      bindingCurPage: 1
    };
  },
  created() {
    this.getData();
  },
  methods: {
    formatInstanceStatus(status) {
      const map = { 0: '正常', 1: '已用完', 2: '已过期' };
      return map[status] !== undefined ? map[status] : status;
    },
    getData() {
      let self = this;
      let Params = { ...self.searchForm };
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      GiftCardApi.instanceList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = (data.data && data.data.list && data.data.list.data) ? data.data.list.data : [];
          self.totalDataNumber = (data.data && data.data.list && data.data.list.total) ? data.data.list.total : 0;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    onSubmit() {
      this.curPage = 1;
      this.getData();
    },
    showDetail(row) {
      this.detailRow = row;
      this.detailVisible = true;
    },
    showLedger(row) {
      let self = this;
      GiftCardApi.ledgerByCardNo({ id: row.id }, true)
        .then(data => {
          self.ledgerDetail = (data.data && data.data.detail) ? data.data.detail : null;
          self.ledgerLogs = (data.data && data.data.logs) ? data.data.logs : [];
          self.ledgerVisible = true;
        })
        .catch(() => {
          self.$message.error('获取流水失败');
        });
    },

    showBinding(row) {
      this.bindingInstanceId = row.id;
      this.bindingCurPage = 1;
      this.fetchBindingList();
      this.bindingVisible = true;
    },

    fetchBindingList() {
      let self = this;
      if (!self.bindingInstanceId) return;
      self.bindingLoading = true;
      GiftCardApi.bindingList({
        id: self.bindingInstanceId,
        page: self.bindingCurPage,
        list_rows: self.bindingPageSize
      }, true).then(res => {
        self.bindingLoading = false;
        const list = res.data && res.data.list ? res.data.list : null;
        self.bindingTableData = list && list.data ? list.data : [];
        self.bindingTotal = list && list.total ? list.total : 0;
      }).catch(() => {
        self.bindingLoading = false;
        self.$message.error('获取绑定记录失败');
      });
    },

    handleBindingSizeChange(val) {
      this.bindingCurPage = 1;
      this.bindingPageSize = val;
      this.fetchBindingList();
    },

    handleBindingCurrentChange(val) {
      this.bindingCurPage = val;
      this.fetchBindingList();
    },
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.curPage = val;
      this.getData();
    }
  }
};
</script>

<style scoped>
.detail-content p {
  margin: 8px 0;
}
.detail-content .label {
  color: #909399;
  margin-right: 8px;
}
.detail-section {
  margin-top: 16px;
  margin-bottom: 4px;
  font-weight: 500;
  color: #303133;
}
</style>



// WEBPACK FOOTER //
// src/views/gift_card/instance_list/index.vue